import { useHasFF } from 'venn-utils';
import { useRecoilValue } from 'recoil';
import {
  allVennDailyPrivateAssetReturnNames,
  blockExcelFunction,
  StudioExcelExportKeys,
  useScopedSetRecoilState,
} from 'venn-state';
import { useCallback, useEffect } from 'react';
import { convertVdparNamesToExcel } from './excel-transformers/convertVdparNamesToExcel';

export const useVdparXLSExport = () => {
  const hasVennDailyPrivateAssetReturnsFF = useHasFF('venn_daily_private_asset_returns_ff');
  const vdparNames = useRecoilValue(allVennDailyPrivateAssetReturnNames);

  const excelFunction = useCallback(() => convertVdparNamesToExcel(vdparNames), [vdparNames]);

  const setExportFunction = useScopedSetRecoilState(blockExcelFunction(StudioExcelExportKeys.VDPAR));

  useEffect(() => {
    setExportFunction({
      excelFunction: hasVennDailyPrivateAssetReturnsFF && vdparNames.length ? excelFunction : undefined,
    });
  }, [setExportFunction, excelFunction, hasVennDailyPrivateAssetReturnsFF, vdparNames.length]);
};
